"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlockRegistry = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
class BlockRegistry {
  get root() {
    return this.rootBlock;
  }
  constructor(types) {
    (0, _defineProperty2.default)(this, "blocks", new Map());
    (0, _defineProperty2.default)(this, "index", 1);
    (0, _defineProperty2.default)(this, "rootBlock", void 0);
    this.types = types;
  }
  setRoot(block) {
    this.rootBlock = block;
  }
  register(block) {
    let key = this.index++;
    this.blocks.set(key, block);
    return key;
  }
  get(key) {
    return this.blocks.get(key);
  }
  remove(block) {
    this.blocks.delete(block.key);
  }
  getWrap(key) {
    return Object.freeze({
      block: this.get(key)
    });
  }
  destroy() {
    for (let block of this.blocks.values()) {
      block.destroy();
    }
    this.blocks = new Map();
  }
}
exports.BlockRegistry = BlockRegistry;
//# sourceMappingURL=BlockRegistry.js.map